/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_cognito_region": "eu-west-1",
    "aws_user_pools_id": "eu-west-1_RrJYnGsj0",
    "aws_user_pools_web_client_id": "2c6c4fdigss54a9vj8ek26j98r",
    "oauth": {},
    "aws_cloud_logic_custom": [
        {
            "name": "AdminQueries",
            "endpoint": "'https://4i27mpj3x8.execute-api.eu-west-1.amazonaws.com/staging}",
            "region": "eu-west-1"
        }
    ],
    "aws_appsync_graphqlEndpoint": "https://qmd7imazwfg2nl5crsswbkg4ni.appsync-api.eu-west-1.amazonaws.com/graphql",
    "aws_appsync_region": "eu-west-1",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_appsync_apiKey": ""
};

export default awsmobile;
